import { render, staticRenderFns } from "./PoliticaDePrivacidad.vue?vue&type=template&id=e7464098&scoped=true&"
import script from "./PoliticaDePrivacidad.vue?vue&type=script&lang=js&"
export * from "./PoliticaDePrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./PoliticaDePrivacidad.vue?vue&type=style&index=0&id=e7464098&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7464098",
  null
  
)

export default component.exports